import React from 'react';

import { TimelineOffCanvas } from '../../../components/TimelineOffCanvas';
import PatientTimeline from '../../../components/Timeline/PatientTimeline';
import { InsightsOffCanvas } from '../../../components/InsightsOffCanvas';
import { ActionOffCanvas } from '../../../components/ActionOffCanvas';
import { useMedicareTimeline } from '../hooks/useMedicareTimeline';
import type { MedicareTimelineProps } from '../types';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';

const MedicareTimeline: React.FC<MedicareTimelineProps> = ({
  isLoading,
  sendToParent,
}) => {
  const {
    groups,
    items,
    startDate,
    endDate,
    clinicianId,
    dashSettings,
    features,
    isInsightEvent,
    setIsInsightEvent,
    isActionEvent,
    setIsActionEvent,
    openInsightDetails,
    insightCloseHandler,
    saveDefaultZoom,
    requestRefresh,
  } = useMedicareTimeline();
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const defaultCollapsed =
    !!selectedTenancy?.features?.timelineConfig?.collapsedByDefault;

  const renderOffCanvas = (): JSX.Element => {
    if (isInsightEvent) {
      return <InsightsOffCanvas sendToParent={sendToParent} />;
    } else if (isActionEvent) {
      return <ActionOffCanvas />;
    } else {
      return (
        <TimelineOffCanvas
          sendToParent={sendToParent}
          closeInsightDetails={insightCloseHandler}
          requestRefresh={requestRefresh}
        />
      );
    }
  };

  return (
    <div id="patient-timeline" className="mb-5">
      {!isLoading && (
        <>
          <PatientTimeline
            defaultCollapsed={defaultCollapsed}
            groups={groups}
            items={items}
            startDate={startDate}
            endDate={endDate}
            isSimple={true}
            clinician_id={clinicianId}
            dashSettings={dashSettings}
            saveDefaultZoom={saveDefaultZoom}
            openInsightDetails={openInsightDetails}
            closeInsightDetails={insightCloseHandler}
            setIsInsightEvent={setIsInsightEvent}
            setIsActionEvent={setIsActionEvent}
            features={features}
          />
          {renderOffCanvas()}
        </>
      )}
    </div>
  );
};

export { MedicareTimeline };
